import React from 'react';
import { mailToLink } from '../util/share';
import { appContext } from '../util/decorators';

@appContext
export default class Mail extends React.PureComponent {
  static propTypes = {
    title: React.PropTypes.string.isRequired,
    url: React.PropTypes.string.isRequired,
  };

  render() {
    const link = mailToLink({
      subject: this.props.title,
      body: this.props.url,
    });

    return (
      <a className="share-button share-mail" href={link}>
        <span className="icon-container">
          <i className="icon-email"></i>
        </span>

        <span className="structural">{this.context.app.t('Mail.email')}</span>
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Mail.jsx